import { Component } from '@angular/core';
import { SnackbarComponent } from '../snackbar/snackbar.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { take } from 'rxjs';
import { SnackBarModel, ModalData } from '../../models';
import { ModalComponent } from '../modal/modal.component';
import { LogService } from '../../services/log.service';
import { SingleModalComponent } from '../single-modal/single-modal/single-modal.component';

@Component({
    selector: 'app-show-alerts',
    template: '',
    standalone: false
})
export class ShowAlertsComponent {
  data!: SnackBarModel;
  modalData!: ModalData;
  /**
   * @constructor
   * @param {Router} router - The router service.
   * @param {ActivatedRoute} route - The activated route service.
   * @param {MatSnackbar} snackBar - Snackbar to show messages.
   * @param {MatDialog} dialog - Popup service.
   */
  constructor(
    public router: Router,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    public logger: LogService
  ) {}

  /**
   * open snackbar to show custom messages
   * @param {any} data : Data with display info
   * @param {number} duration : Snackbar duration
   * @param {string} type: Sends what snackbar type we want (error, success)
   * @public
   */
  openSnackBar(data: any, duration: number, type: string) {
    this.snackBar.openFromComponent(SnackbarComponent, {
      duration: duration * 3000,
      data: data,
      panelClass: [type],
    });
  }

  /**
   * Triggers openSnackBar to show an error on the process.
   * Sets data for snackbar error.
   * @param {string} error : Error to show on title
   * @public
   */
  showError(err: any, info?: any) {
    if (info) {
      if (info.detail) {
        var detail = info.detail.split('*').pop();
        this.data = {
          title: detail,
          buttonText: 'Dismiss',
        };
      } else if (info.error){
        var detail = info.error.detail.split('*').pop();
        this.data = {
          title: detail,
          buttonText: 'Dismiss',
        };
      } else {
        this.data = {
          title: 'Error!',
          buttonText: 'Dismiss',
        };
      }
    } else {
      this.data = {
        title: err,
        buttonText: 'Dismiss',
      };
    }
    this.openSnackBar(this.data, 5, 'error-snackbar');

    if (info) {
      var message;
      if (info.detail) {
        var detail = info.detail.split('*').pop();
        message = {
          message: info.detail,
          status: info.status,
          extraInfo: info.conflict,
        };
      } else {
        message = {
          message: info.message,
          status: info.statusCode,
          extraInfo: info.errors,
        };
      }
      this.logger.error(message);
    }
  }

  /**
   * Called if user clicks cancel button on Dialog
   * triggers openDialog with cancel information
   * @public
   */
  cancel(route: string): void {
    this.data = {
      title: 'Operation cancelled',
      buttonText: 'Dismiss',
    };
    this.modalData = {
      title: 'Are you sure you want to cancel this operation?',
      content: 'All changes done will be lost',
      acceptText: 'Yes',
      declineText: 'No',
    };
    this.openDialog(this.modalData, route);
  }

  /**
   * Opens new dialog
   * After closed if selected 'yes', redirects and shows snackbar.
   * @param {ModalData} modalData : data to show
   * @public
   */
  openDialog(modalData: ModalData, route: string, data?: any) {
    const dialogRef = this.dialog.open(ModalComponent, {
      data: modalData,
    });
    if(data){
      this.data = data;
    }
    dialogRef
      .afterClosed()
      .pipe(take(1))
      .subscribe((result) => {
        if (result) {
          this.openSnackBar(this.data, 2, 'error-snackbar');
          this.router.navigate([route]);
        }
      });
  }

  /**
   * Triggers snackbar with success message.
   * Resets the form
   * Navigates back to route
   * @public
   */
  onSaveComplete(route: string, title?: string): void {
    this.data = {
      title: 'Record saved!',
      buttonText: 'Dismiss',
    };
    if (title) {
      this.data.title = title;
    }
    this.openSnackBar(this.data, 3, 'success-snackbar');
    this.router.navigate([route]);
  }

   /**
   * Navigates to grid page
   * @public
   */
   returnToGrid(route: string, dirty?: boolean): void {
    var data = {
      title: 'Operation cancelled',
      buttonText: 'Dismiss',
    };
    if (dirty) {
      var modalData = {
        title: 'Are you sure you want to cancel this operation?',
        content: 'All changes done will be lost',
        acceptText: 'Yes',
        declineText: 'No',
      };
      this.openDialog(modalData, route, data);
    } else {
      this.openSnackBar(data, 2, 'error-snackbar');
      this.router.navigate([route]);
    }
  }


  /**
   * Opens new dialog
   * Usually is for showing errors on screen instead of snackbar
   * @param {ModalData} modalData : data to show
   * @public
   */
  openSingleModal(modalData: ModalData) {
    const dialogRef = this.dialog.open(SingleModalComponent, {
      data: modalData,
    });
  }
}
